import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';
import Modal from '@/components/Modal';

import { fetchLoadData } from '@/modules/User';

import { Flex, Box } from 'UIKit/Grid';
import { StyledButton } from 'UIKit/Form';

import Achievements from '@/components/Gamification/Achievements';

import { NewRankModalComponent } from '@/pages/profile/PanelInfo';

import FeatherIcon from '@/assets/img/FeatherIcon.png';

export const Modals = ({ user, data, updateUser, close, preventReload }) => {
  const [open, setOpen] = useState([]);

  useEffect(() => {
    const list = [];
    data.forEach((item, index) => {
      list[index] = true;
    });
    setOpen(list);

    if (data && data.length > 0 && !preventReload && user._id) {
      // Если геймификация приходит в /me, то возникает бесконечный цикл - обновления должны удаляться после отображения
      // Обновление необходимо для синхронизации профиля с геймификацией
      updateUser();
    }
  }, [data]);

  const closeModal = index => {
    setOpen(prevState =>
      prevState.map((item, idx) => (idx === index ? !item : item))
    );
    close();
  };

  const achivements =
    user.role === 1 ? Achievements.student : Achievements.teacher;

  return (
    <>
      {data &&
        data.map((item, index) => (
          <>
            {item.showNewRankModal && <NewRankModalComponent />}
            {!item.showNewRankModal && (
              <Modal show={open[index]} close={() => closeModal(index)}>
                {item.id != null &&
                achivements.find(i => i.id === item.id) != null ? (
                  <Flex flexDirection="column" alignItems="center">
                    <Box style={{ fontSize: '18px' }}>
                      Поздравляем, у вас новое достижение!
                    </Box>
                    <Box mt={8}>
                      <img
                        src={achivements.find(i => i.id === item.id).icon}
                        alt=""
                      />
                    </Box>
                    <Box
                      style={{ fontSize: '16px', fontWeight: 'bold' }}
                      mt={3}
                    >
                      {achivements.find(i => i.id === item.id).title}
                    </Box>
                    <Box style={{ fontSize: '12px' }} mt={1}>
                      {achivements.find(i => i.id === item.id).desc}
                    </Box>
                    <Flex
                      mt={4}
                      mb={9}
                      style={{
                        backgroundColor: '#EAECF2',
                        fontSize: '9px',
                        textAlign: 'center',
                      }}
                    >
                      {item.feathers ? (
                        <Box p={2}>
                          <Box>+{item.feathers}</Box>
                          <Box>Перья</Box>
                        </Box>
                      ) : (
                        ''
                      )}
                      {item.experiences ? (
                        <Box p={2}>
                          <Box>+{item.experiences}</Box>
                          <Box>Опыта</Box>
                        </Box>
                      ) : (
                        ''
                      )}
                      {item.scores ? (
                        <Box p={2}>
                          <Box>+{item.scores}</Box>
                          <Box>Баллов</Box>
                        </Box>
                      ) : (
                        ''
                      )}
                    </Flex>
                    <StyledButton onClick={() => closeModal(index)}>
                      Отлично!
                    </StyledButton>
                  </Flex>
                ) : (
                  <Flex flexDirection="column" alignItems="center">
                    <Box style={{ fontSize: '18px' }}>
                      За эту попытку тебе начислено:
                    </Box>
                    <Flex mt={9} mb={10}>
                      <Flex
                        alignItems="center"
                        alignContent="center"
                        justifyContent="center"
                        width="80px"
                        height="80px"
                        style={{
                          backgroundColor: '#EAECF2',
                          borderRadius: '10px',
                        }}
                        mr={5}
                      >
                        <img src={FeatherIcon} alt="" />
                      </Flex>
                      <Flex
                        alignItems="center"
                        alignContent="center"
                        justifyContent="center"
                        width="80px"
                        height="80px"
                        style={{
                          backgroundColor: '#EAECF2',
                          fontSize: '14px',
                          borderRadius: '10px',
                          textAlign: 'center',
                        }}
                      >
                        +{item.feathers}
                        <br />
                        Перья
                      </Flex>
                    </Flex>
                    <StyledButton onClick={() => closeModal(index)}>
                      Отлично!
                    </StyledButton>
                  </Flex>
                )}
              </Modal>
            )}
          </>
        ))}
    </>
  );
};

Modals.propTypes = {
  user: PropTypes.object.isRequired,
  data: PropTypes.array.isRequired,
  updateUser: PropTypes.func.isRequired,
  close: PropTypes.func,
  preventReload: PropTypes.bool,
};

Modals.defaultProps = {
  close: () => true,
  preventReload: false,
};

const mapStateToProps = state => ({
  user: state.user,
});

const mapDispatchToProps = dispatch => ({
  updateUser() {
    dispatch(fetchLoadData());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Modals);
